module.exports = __webpack_public_path__ + "static/img/formBg.8ddc5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/password/login/formBg.jpg
// module id = s5iw
// module chunks = 157